module.exports = __webpack_public_path__ + "static/img/3.28b7ac8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/eng/3.png
// module id = BTKH
// module chunks = 0